import { createStyles, makeStyles } from '@mui/styles';
import { STYLE } from 'constants/style';

export const useStyles = makeStyles((theme: any) =>
  createStyles({
    accordion: {
      boxShadow: 'none !important',
      border: `1px solid ${STYLE.COLOR.TABS_BORDER} !important`,
      borderRadius: '12px !important',
      paddingLeft: '0px !important',
      paddingRight: '0px !important',
      minHeight: '56px',
      '&:before': {
        display: 'none',
      },
    },
    accordionSummary: {
      minHeight: '56px !important',
      margin: '0 !important',
      padding: '24px !important',
      '& .MuiAccordionSummary-content': {
        color: STYLE.COLOR.TEXT1,
        fontSize: '20px',
        fontWeight: 600,
        lineHeight: '28px',
        margin: '0 !important',
        '@media (max-width: 600px)': {
          fontSize: '14px',
          lineHeight: '24px',
        },
      },
      '&.Mui-expanded': {
        margin: '0 !important',
      },
      '@media (max-width: 600px)': {
        padding: '12px 16px !important',
      },
    },
    accordionDetails: {
      padding: '24px !important',
      paddingTop: '8px !important',
      '@media (max-width: 600px)': {
        padding: '8px 16px 12px 16px !important',
      },
    },
    arrowIcon: {
      '& path': { stroke: STYLE.COLOR.ACCENT_PRIMARY },
    },
  }),
);
